import React from 'react';
import { Padding } from '@extensions/AttributePanel/components/attributes/Padding';
import { ContainerBackgroundColor } from '@extensions/AttributePanel/components/attributes/ContainerBackgroundColor';
import { BorderWidth } from '@extensions/AttributePanel/components/attributes/BorderWidth';
import { BorderStyle } from '@extensions/AttributePanel/components/attributes/BorderStyle';
import { BorderColor } from '@extensions/AttributePanel/components/attributes/BorderColor';
import { Width } from '@extensions/AttributePanel/components/attributes/Width';
import { Align } from '@extensions/AttributePanel/components/attributes/Align';
import { pixelAdapter } from '../../adapter';

import { Collapse, Grid } from '@arco-design/web-react';
import { TextStyle } from '@bay-email/editor';
import { ClassName } from '../../attributes/ClassName';
import { CollapseWrapper } from '../../attributes/CollapseWrapper';
import { t } from '@bay-email/core';

export function Divider() {
	return (
		<CollapseWrapper
			isChevron
			iconPosition='right'
			defaultActiveKey={['1', '2']}
			style={{ padding: 0 }}
		>
			<Collapse.Item
				name='1'
				header={t('Dimension')}
				contentStyle={{ padding: 0 }}
			>
				<div className='p-3'>
					<Grid.Row
						gutter={16}
						style={{ marginBottom: '16px' }}
					>
						<Grid.Col span={12}>
							<div style={{ paddingRight: '8px' }}>
								<Width
									unitOptions='percent'
									defaultUnit='%'
									config={pixelAdapter}
									maxPx={600}
									helpText={t('Maximum width is 600px')}
								/>
							</div>
						</Grid.Col>
					</Grid.Row>
					<Padding />
				</div>
			</Collapse.Item>

			<Collapse.Item
				name='2'
				header={t('Styling')}
				contentStyle={{ padding: 0 }}
			>
				<div className='p-3'>
					<Grid.Row gutter={16}>
						<Grid.Col span={12}>
							<ContainerBackgroundColor title={t('Background color')} />
						</Grid.Col>
					</Grid.Row>
					<Align />
					<TextStyle
						variation='strong'
						style={{ marginBottom: '12px', marginTop: '16px', display: 'block' }}
					>
						{t('Border')}
					</TextStyle>
					<Grid.Row gutter={16}>
						<Grid.Col span={10}>
							<BorderColor secondary />
						</Grid.Col>
						<Grid.Col span={8}>
							<BorderWidth
								secondary
								config={pixelAdapter}
								label={t('Thickness (px)')}
							/>
						</Grid.Col>
						<Grid.Col span={6}>
							<BorderStyle secondary />
						</Grid.Col>
					</Grid.Row>
				</div>
			</Collapse.Item>

			<Collapse.Item
				name='4'
				header={t('Extra')}
				contentStyle={{ padding: 0 }}
			>
				<div className='p-3'>
					<ClassName />
				</div>
			</Collapse.Item>
		</CollapseWrapper>
	);
}
